import React, { Component } from 'react';
import styled from 'styled-components';
import { Collapse } from 'react-collapse';
import SingleMeal from './SingleMeal';
import ArrowIcon from '../../../images/arrow-black.png';

export default class SingleDayMenu extends Component {
  state = {
    isOpened: false,
  };

  open = () => {
    const { isOpened } = this.state;
    this.setState({ isOpened: !isOpened });
  };

  renderMeals = () => {
    const { menu } = this.props;
    return (
      <div>
        {menu.morning.length > 0 && <SingleMeal meal={menu.morning} name="Утро" />}
        {menu.breakfast.length > 0 && <SingleMeal meal={menu.breakfast} name="Завтрак" />}
        {menu.breakfastSnack.length > 0 && (
          <SingleMeal meal={menu.breakfastSnack} name="Утренний перекус" />
        )}
        {menu.lunch.length > 0 && <SingleMeal meal={menu.lunch} name="Обед" />}
        {menu.lunchSnack.length > 0 && (
          <SingleMeal meal={menu.lunchSnack} name="Обеденный перекус" />
        )}
        {menu.dinner.length > 0 && <SingleMeal meal={menu.dinner} name="Ужин" />}
        {menu.dinnerSnack.length > 0 && <SingleMeal meal={menu.dinnerSnack} name="Перед сном" />}
      </div>
    );
  };

  render() {
    const { dayNumber } = this.props;
    const { isOpened } = this.state;

    return (
      <SingleDayItem>
        <Name onClick={this.open}>
          <ImgArrow src={ArrowIcon} alt="arrow" isOpened={isOpened} />
          День {dayNumber}
        </Name>
        <Collapse isOpened={isOpened}>{this.renderMeals()}</Collapse>
      </SingleDayItem>
    );
  }
}

const SingleDayItem = styled.div`
  width: 80%;
  margin: 15px auto;
  box-sizing: border-box;
  border: 2px solid #c1c1c1;
  border-radius: 5px;
  @media (max-width: 768px) {
    width: 90%;
  }
`;

const Name = styled.div`
  position: relative;
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 20px;
  text-align: center;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  background: #fff;
  @media (max-width: 500px) {
    padding-left: 50px;
  }
`;

const ImgArrow = styled.img`
  position: absolute;
  left: 15px;
  bottom: 10px;
  width: 25px;
  height: 25px;
  transition: 0.3s;
  transform: ${(props) => (props.isOpened ? 'rotate(270deg)' : 'rotate(90deg)')};
`;



// WEBPACK FOOTER //
// ./src/Components/Templates/TemplatesList/SingleDayMenu.jsx